export default {
    driver_performance_events_drawer_event: "Event",
    driver_performance_events_drawer_when: "Date/Timestamp",
    driver_performance_events_drawer_driver: "Driver",
    driver_performance_events_drawer_asset: "Asset",
    driver_performance_events_drawer_no_data: "No data available",
    driver_performance_events_drawer_severity: "Severity",
    driver_performance_events_drawer_category: "Category",
    driver_performance_events_drawer_risk: "Risk",
    driver_performance_events_drawer_source: "Source",
    driver_performance_events_drawer_camera: "Camera",
    driver_performance_events_drawer_event_type: "Event Type",
    driver_performance_events_drawer_status: "Status",
    driver_performance_events_drawer_driver_challenged: "Driver Challenged",
    driver_performance_highlightcoaching: "Highlight Coaching",
    driver_performance_falsepositive: "False Positive",
    driver_performance_verified: "Verified",
    driver_performance_noissue: "No Issue",
    driver_performance_severity_warning: "Warning",
    driver_performance_severity_default: "Default",
    driver_performance_severity_medium: "Medium",
    driver_performance_severity_low: "Low",
    driver_performance_severity_high: "High",
    driver_performance_severity_critical: "Critical",
    driver_performance_unassigned: "Unassigned",
};
